import * as React from "react";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";

declare let $: any;
declare global {
    interface Window {
        initialState: any;
        app : any;
    }
}

export default class NewTuning extends React.Component<any, any> {
    userAgent : string;

    constructor(props: any) {
        super(props);
        this.state = {
            notes : '',
            name : ''
        };
    }

    // componentDidMount() {
    //     this.setState({tunings : [{"name" : 123}]});
    // }

    saveTuning (event) {
        ($ as any).ajax({
            url: '/api/v1/tuning',
            type: 'POST',
            contentType: "application/json",
            data: JSON.stringify({
                name : this.state.name,
                notes : this.state.notes,
                instrument : this.props.instrument
            }),
            success: function (result) {
                window.location.reload();
            }
        });

    };

    handleNameChange(event) {
        this.setState({name: event.target.value});
    }

    handleNotesChange(event) {
        this.setState({notes: event.target.value});
    }

    render() {
        const textFieldStyle = {
            boxShadow : "inset 0 0px 0px"
        };

        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.props.dialogClose}
            />,
            <FlatButton
                label="Save"
                primary={true}
                keyboardFocused={true}
                onTouchTap={this.saveTuning.bind(this)}
            />,
        ];

        const customContentStyle = {
            width: '450px',
            maxWidth: 'none',
        };

        return <Dialog
                    title="New Tuning"
                    actions={actions}
                    modal={false}
                    open={this.props.dialogShown}
                    onRequestClose={this.props.dialogClose}
                    contentStyle={customContentStyle}
                >
                    <TextField  id="tbName"
                                required={true}
                                hintText=""
                                value={this.state.name}
                                onChange={this.handleNameChange.bind(this)}
                                inputStyle={textFieldStyle}
                                floatingLabelText="Name"
                    /><br />
                    <TextField  id="tbNotes"
                                required={true}
                                value={this.state.notes}
                                onChange={this.handleNotesChange.bind(this)}
                                hintText="E2 B2 C3 etc."
                                inputStyle={textFieldStyle}
                                floatingLabelText="Tuning Notes"
                    /><br />
                </Dialog>;
    }
}


// WEBPACK FOOTER //
// ./components/guitar/NewTuning.tsx